import _ from 'lodash';

export const getRouteGuarantorId = () => {
    return getGuarantorIdHref() || getGuarantorIdState();
};

export const getGuarantorIdHref = (): string | undefined => {
    const guarantorIdRegex = RegExp(/guarantors\/([\w-]+)/gi);

    const match = guarantorIdRegex.exec(window.location.href);

    return match ? match[1] : undefined;
};

export const getGuarantorIdState = (): string | undefined => {
    return _.get(history, 'location.state.guarantorId');
};
